import { AuthError } from "../errors/AuthError.js";
/**
 * APIクライアントクラス
 *
 * バックエンドAPIとの通信を担当する低レベルHTTPクライアント
 */
export class ApiClient {
    config;
    /**
     * コンストラクタ
     *
     * @param config - ApiClient設定
     */
    constructor(config) {
        // baseUrlはundefined/nullチェックのみ（空文字列は許可: 同じオリジンを使用）
        if (config.baseUrl === undefined || config.baseUrl === null) {
            throw new Error("baseUrl is required");
        }
        this.config = config;
    }
    /**
     * POSTリクエストを送信
     *
     * @param path - リクエストパス
     * @param body - リクエストボディ
     * @param options - 追加のRequestInitオプション
     * @returns レスポンスデータ
     */
    async post(path, body, options) {
        return this.request("POST", path, body, options);
    }
    /**
     * GETリクエストを送信
     *
     * @param path - リクエストパス
     * @param options - 追加のRequestInitオプション
     * @returns レスポンスデータ
     */
    async get(path, options) {
        return this.request("GET", path, undefined, options);
    }
    /**
     * HTTPリクエストを送信（内部メソッド）
     *
     * @param method - HTTPメソッド
     * @param path - リクエストパス
     * @param body - リクエストボディ（オプション）
     * @param options - 追加のRequestInitオプション
     * @returns レスポンスデータ
     */
    async request(method, path, body, options) {
        const url = `${this.config.baseUrl}${path}`;
        // アクセストークンの付与
        const token = this.config.getAccessToken();
        const headers = {
            "Content-Type": "application/json",
            ...options?.headers,
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };
        try {
            const response = await fetch(url, {
                method,
                headers,
                body: body ? JSON.stringify(body) : undefined,
                ...options,
            });
            return this.handleResponse(response);
        }
        catch (error) {
            if (error instanceof AuthError) {
                throw error;
            }
            throw new AuthError("NETWORK_ERROR", error instanceof Error ? error.message : "Network error occurred");
        }
    }
    /**
     * レスポンスを処理（内部メソッド）
     *
     * @param response - Fetchレスポンス
     * @returns レスポンスデータ
     */
    async handleResponse(response) {
        if (response.ok) {
            return response.json();
        }
        // エラーレスポンスの処理
        return this.handleError(response);
    }
    /**
     * エラーレスポンスを処理（内部メソッド）
     *
     * @param response - Fetchレスポンス
     * @throws AuthError
     */
    async handleError(response) {
        let errorBody;
        try {
            errorBody = (await response.json());
        }
        catch {
            // JSONパースエラー時のフォールバック
            throw new AuthError("INTERNAL_001", `HTTP ${response.status}: ${response.statusText}`);
        }
        // 401エラー時のコールバック実行
        if (response.status === 401 && this.config.onUnauthorized) {
            this.config.onUnauthorized();
        }
        throw new AuthError((errorBody.error_code || "INTERNAL_001"), errorBody.message, errorBody.details);
    }
}
//# sourceMappingURL=ApiClient.js.map